import { reactive } from 'vue';

export const criarManutPlanoItem = () => {
    return reactive({
        id: 0,
        idplano: 0,
        idservico: 0,
        intervalo_km: 0,
        intervalo_horas: 0,
        intervalo_dias: 0,
        intervalo_meses: 0,
        antecedencia_km: 0,
        antecedencia_horas: 0,
        antecedencia_dias: 0,
        detalhamento: '',
        ativo: 'S',
        idlogin: 0
    });
}
